import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateNotificationState, UpdateAvailablePayload } from "@common/types/update-notification-types";
import { isExtensionContext } from "@common/services/detect-context";

const initialState: UpdateNotificationState = {
  updateAvailable: false,
  currentVersion: isExtensionContext() && chrome.runtime.getManifest ? chrome.runtime.getManifest().version : "",
  newVersion: null,
  modalDismissed: false,
  lastChecked: null,
  isCheckingForUpdate: false,
};

export const updateNotificationSlice = createSlice({
  name: "updateNotification",
  initialState,
  reducers: {
    setUpdateAvailable: (state, action: PayloadAction<UpdateAvailablePayload>) => {
      state.updateAvailable = true;
      state.currentVersion = action.payload.currentVersion;
      state.newVersion = action.payload.newVersion;
      state.modalDismissed = false; // Reset dismissed state for new version
      state.lastChecked = Date.now();
      console.log('[UpdateNotification] Update available:', {
        currentVersion: state.currentVersion,
        newVersion: state.newVersion,
      });
    },
    dismissUpdateModal: (state) => {
      state.modalDismissed = true;
      console.log('[UpdateNotification] Modal dismissed');
    },
    clearUpdateNotification: (state) => {
      state.updateAvailable = false;
      state.newVersion = null;
      state.modalDismissed = false;
      console.log('[UpdateNotification] Notification cleared');
    },
    setCheckingForUpdate: (state, action: PayloadAction<boolean>) => {
      state.isCheckingForUpdate = action.payload;
    },
    updateLastChecked: (state) => {
      state.lastChecked = Date.now();
    },
  },
});

export const {
  setUpdateAvailable,
  dismissUpdateModal,
  clearUpdateNotification,
  setCheckingForUpdate,
  updateLastChecked,
} = updateNotificationSlice.actions;

export default updateNotificationSlice.reducer;
